(function () {
  'use strict';

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function ensureControlNames(root) {
    root.querySelectorAll('button:not([aria-label]):not([aria-labelledby])').forEach(function (button) {
      if (textOf(button)) return;
      if (button.matches('.owl-prev, [data-slide="prev"], [name="previous"]')) button.setAttribute('aria-label', 'Previous slide');
      else if (button.matches('.owl-next, [data-slide="next"], [name="next"]')) button.setAttribute('aria-label', 'Next slide');
      else if (button.matches('.owl-dot, .slider-counter__link')) {
        var siblings = Array.from(button.parentElement ? button.parentElement.children : []);
        button.setAttribute('aria-label', 'Go to slide ' + (siblings.indexOf(button) + 1));
      } else if (button.matches('[class*="close"], [data-close]')) button.setAttribute('aria-label', 'Close');
    });

    root.querySelectorAll('input:not([type="hidden"]):not([aria-label]):not([aria-labelledby])').forEach(function (input) {
      if (input.labels && input.labels.length) return;
      if (input.type === 'search') input.setAttribute('aria-label', 'Search products');
      else if (input.type === 'email') input.setAttribute('aria-label', 'Email address');
      else if (input.type === 'number') input.setAttribute('aria-label', 'Quantity');
    });

    root.querySelectorAll('.owl-prev').forEach(function (button) { button.setAttribute('aria-label', 'Previous slide'); });
    root.querySelectorAll('.owl-next').forEach(function (button) { button.setAttribute('aria-label', 'Next slide'); });

    root.querySelectorAll('a[href*="wishlist"]:not([aria-label]):not([aria-labelledby])').forEach(function (link) {
      var count = textOf(link).match(/\d+/);
      link.setAttribute('aria-label', count ? 'Wishlist, ' + count[0] + ' items' : 'Wishlist');
    });
  }

  function updatePageFilterStatus(queryOverride) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var items = Array.from(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;
    var input = document.querySelector('[data-page-product-search]');
    var query = typeof queryOverride === 'string' ? queryOverride.trim() : (input ? input.value.trim() : '');
    var visibleCount = items.filter(function (item) { return !item.hidden; }).length;
    document.querySelectorAll('[data-page-filter-status]').forEach(function (status) {
      status.textContent = query
        ? visibleCount + ' of ' + items.length + ' shown products match “' + query + '”.'
        : 'Showing ' + visibleCount + ' of ' + items.length + ' products loaded on this page.';
    });
  }

  function installPageFilterStatus() {
    if (document.documentElement.dataset.srPageFilterStatus === 'true') {
      updatePageFilterStatus();
      return;
    }
    document.documentElement.dataset.srPageFilterStatus = 'true';
    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-page-product-search]')) return;
      var query = event.target.value;
      window.setTimeout(function () { updatePageFilterStatus(query); }, 0);
    });
    updatePageFilterStatus();
  }

  function repairDestinations(root) {
    root.querySelectorAll('a[href="/"], a[href$="7realms.net/"]').forEach(function (link) {
      if (/^events?$/i.test(textOf(link))) link.setAttribute('href', '/pages/events');
    });

    root.querySelectorAll('a[href*="/pages/social-media"]').forEach(function (link) {
      if (link.closest('.tcg-social-links, [class*="social"]')) link.hidden = true;
    });
  }

  function normalizeText(root) {
    root.querySelectorAll('option, label, button, a, span').forEach(function (element) {
      if (element.childElementCount) return;
      if (textOf(element) === 'Select Conditon') element.textContent = 'Select Condition';
    });
  }

  function installSearchSubmitFallback(root) {
    root.querySelectorAll('form[role="search"]').forEach(function (form) {
      if (form.dataset.srSearchSubmit === 'true') return;
      form.dataset.srSearchSubmit = 'true';
      var input = form.querySelector('input[type="search"][name="q"]');
      if (!input) return;
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.isComposing) return;
        var selected = form.querySelector('[aria-selected="true"] a');
        if (selected) return;
        var query = input.value.trim();
        if (!query) {
          event.preventDefault();
          return;
        }
        event.stopImmediatePropagation();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, true);
    });
  }

  function liveRegion() {
    var region = document.getElementById('sr-cart-live-region');
    if (!region) {
      region = document.createElement('div');
      region.id = 'sr-cart-live-region';
      region.className = 'sr-cart-live-region';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    return region;
  }

  var drawerRefreshTimer = 0;
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.refreshCartContent !== 'function') return;
    window.clearTimeout(drawerRefreshTimer);
    drawerRefreshTimer = window.setTimeout(function () { drawer.refreshCartContent().catch(function () {}); }, 120);
  }

  function announceCart(event) {
    var quantity = Number(event && event.detail && event.detail.quantity) || 1;
    liveRegion().textContent = quantity === 1 ? 'Item added to cart.' : quantity + ' items added to cart.';
    refreshDrawer();
    refreshInCartIndicators();
  }

  function emitJourneyEvent(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    document.dispatchEvent(new CustomEvent('sevenrealms:journey', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function installJourneyTracking() {
    document.addEventListener('click', function (event) {
      var discovery = event.target.closest('.brand-carousel__link, .collection-discovery__link');
      if (discovery) emitJourneyEvent('sr_discovery_click', { label: textOf(discovery), destination: discovery.getAttribute('href') });

      var recovery = event.target.closest('.sr-search-recovery__link');
      if (recovery) emitJourneyEvent('sr_search_recovery', { label: textOf(recovery), destination: recovery.getAttribute('href') });

      var filter = event.target.closest('.collection-stock-filter__link, [data-products-per-page], .mobile-filter-trigger');
      if (filter) emitJourneyEvent('sr_collection_refine', { label: textOf(filter), value: filter.value || filter.dataset.stockMode || '' });

      var productAction = event.target.closest('.feat-buy-btn, .product-add-to-cart, [data-offer-add]');
      if (productAction) emitJourneyEvent('sr_product_action', { label: textOf(productAction), product_id: productAction.dataset.productId || '' });

      var checkout = event.target.closest('#checkout, #CartDrawer-Checkout, [name="checkout"]');
      if (checkout) emitJourneyEvent('sr_checkout_start', { source: checkout.id || 'cart' });

      var reviewCart = event.target.closest('.sr-cart-review-button');
      if (reviewCart) emitJourneyEvent('sr_cart_review', { destination: reviewCart.getAttribute('href') });
    });
    document.addEventListener('change', function (event) {
      var control = event.target.closest('[data-products-per-page], .collection-product-type-filter select, .facet-filters__sort');
      if (control) emitJourneyEvent('sr_collection_refine', { label: textOf(control.options && control.options[control.selectedIndex]), value: control.value || '' });
    });
  }

  function refreshInCartIndicators() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : Promise.reject(); })
      .then(function (cart) {
        var ids = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
        document.querySelectorAll('.collection-product-card[data-product-id], .feat-collection-card[data-product-id]').forEach(function (card) {
          var inCart = ids.has(String(card.dataset.productId));
          var badge = card.querySelector(':scope > .sr-in-cart-badge');
          if (inCart && !badge) {
            badge = document.createElement('span');
            badge.className = 'sr-in-cart-badge';
            badge.textContent = 'In your cart';
            card.prepend(badge);
          } else if (!inCart && badge) {
            badge.remove();
          }
        });
      })
      .catch(function () {});
  }

  function apply(root) {
    ensureControlNames(root);
    repairDestinations(root);
    normalizeText(root);
    installSearchSubmitFallback(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    apply(document);
    installPageFilterStatus();
    liveRegion();
    installJourneyTracking();
    refreshInCartIndicators();
  });
  document.addEventListener('shopify:section:load', function (event) {
    apply(event.target || document);
    updatePageFilterStatus();
  });
  document.addEventListener('cart:updated', announceCart);
  document.addEventListener('innernerd:cartAdded', announceCart);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('predictive-search[open]').forEach(function (search) {
      if (typeof search.close === 'function') search.close();
    });
  });
})();
